import { axios } from '../http-common';

class Auth {
  login(data) {
    const lang = localStorage.getItem('lang-key')?localStorage.getItem('lang-key'):'en-EN';
    return axios.post("v1/member/auth/login?lang="+lang, data);
  }
  forget(data){
    const lang = localStorage.getItem('lang-key')?localStorage.getItem('lang-key'):'en-EN';
  	return axios.post("v1/member/auth/forget-password?lang="+lang, data);
  }
  resendEmail(data){
    const lang = localStorage.getItem('lang-key')?localStorage.getItem('lang-key'):'en-EN';
  	return axios.post("v1/member/auth/resend-email?lang="+lang, data);
  }
  resetPassword(data){
    const lang = localStorage.getItem('lang-key')?localStorage.getItem('lang-key'):'en-EN';
  	return axios.post("v1/member/reset-password?lang="+lang, data);
  }
  register(data){
    const lang = localStorage.getItem('lang-key')?localStorage.getItem('lang-key'):'en-EN';
  	return axios.post("v1/member/auth/register?lang="+lang, data);
  }
  updatePassword(data){
    return axios.post("v1/member/auth/change-password",data);
  }
  confirmation(data){
    const lang = localStorage.getItem('lang-key')?localStorage.getItem('lang-key'):'en-EN';
    return axios.get("v1/member/auth/mail-confirmation?lang="+lang, {params:data});
  }
}

export default new Auth();